<script context="module">
    import {loadStripe} from "@stripe/stripe-js";

    function cardExpiryOnChange(event) {
        console.log(event);
    }

    function cardCvcOnChange(event) {
        console.log(event);
    }

    function cardNumberOnChange(event) {
        console.log(event);
    }

    export async function createPaymentMethod(stripe, cardElementNumber) {
        const result = await stripe.createPaymentMethod({
            type: 'card',
            card: cardElementNumber,
        });

        return result;
    }

    export async function initStripeCheckoutCardElements(stripePK, cardNumberInputParams, cardCvcInputParams, cardExpiryInputParams, locale = null) {
        let stripe = null;
        if (locale) {
            stripe = await loadStripe(stripePK, {
                locale: locale,
            });
        } else {
            stripe = await loadStripe(stripePK);
        }

        const classes = {
            base: 'form-control',
            focus: 'form-control-focus',
            invalid: 'is-invalid',
        };

        const style = {
            base: {
                fontStyle: 'normal',
                fontWeight: '400',
                fontFamily: 'Roboto, sans-serif',
                fontSize: '18px',
                lineHeight: '21px',
                ':-webkit-autofill': {
                    color: '#696969',
                },
                '::placeholder': {
                    color: '#696969',
                },
            },
            invalid: {
                color: '#DF1B41',
            },
        };

        const cardExpiryInputId = cardExpiryInputParams.elementId;
        const cardCvcInputId = cardCvcInputParams.elementId;
        const cardNumberInputId = cardNumberInputParams.elementId;

        let cardElementNumber = null;
        let cardElementExpiry = null;
        let cardElementCvc = null;
        try {
            const elements = stripe.elements();
            cardElementExpiry = elements.create('cardExpiry', {
                style: (cardExpiryInputParams.style ? cardExpiryInputParams.style : style),
                classes: (cardExpiryInputParams.classes ? cardExpiryInputParams.classes : classes),
                placeholder: cardExpiryInputParams.placeholder ? cardExpiryInputParams.placeholder : null,
            });
            cardElementExpiry.mount(`#${cardExpiryInputId}`);
            cardElementExpiry.on('change', (cardExpiryInputParams.onChange ? cardExpiryInputParams.onChange : cardExpiryOnChange));
            cardElementCvc = elements.create('cardCvc', {
                style: (cardCvcInputParams.style ? cardCvcInputParams.style : style),
                classes: (cardCvcInputParams.classes ? cardCvcInputParams.classes : classes),
                placeholder: cardCvcInputParams.placeholder ? cardCvcInputParams.placeholder : null,
            });
            cardElementCvc.mount(`#${cardCvcInputId}`);
            cardElementCvc.on('change', (cardCvcInputParams.onChange ? cardCvcInputParams.onChange : cardCvcOnChange));
            cardElementNumber = elements.create('cardNumber', {
                style: (cardNumberInputParams.style ? cardNumberInputParams.style : style),
                classes: (cardNumberInputParams.classes ? cardNumberInputParams.classes : classes),
                placeholder: cardNumberInputParams.placeholder ? cardNumberInputParams.placeholder : null,
            });
            cardElementNumber.mount(`#${cardNumberInputId}`);
            cardElementNumber.on('change', (cardNumberInputParams.onChange ? cardNumberInputParams.onChange : cardNumberOnChange));
        } catch (err) {
            console.log(err);
        }

        return {
            stripe: stripe,
            cardElementNumber: cardElementNumber,
            cardElementExpiry: cardElementExpiry,
            cardElementCvc: cardElementCvc,
        };
    }

    export async function initStripeCheckoutPaymentElement(stripePK, paymentElementParams) {
        const stripe = await loadStripe(stripePK);

        try {
            const elements = stripe.elements();
            const paymentElement = elements.create("payment");
            paymentElement.mount(`#${paymentElementParams.elementId}`);
        } catch (error) {
            console.log(error);
        }
    }
</script>